import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { RestClientProvider } from './core/api/RestClientContext';
import { ErrorBoundary } from './core/components/ErrorBoundary';
import { NotificationProvider } from './core/notifications/NotificationContext';
import { ThemeProvider } from './core/theme/ThemeContext';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { ProtectedRoute } from './pages/ProtectedRoute';
import { StatsPage } from './pages/StatsPage';
import { UserDetailsPage } from './pages/UserDetailsPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

function AppContent() {

  return (
    <ErrorBoundary>
    <div className="App">
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className="main-content">
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route path="/" element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          } />
          
          <Route path="/users/:userId" element={
            <ProtectedRoute>
              <UserDetailsPage />
            </ProtectedRoute>
          } />

          <Route path="/stats" element={
            <ProtectedRoute>
              <StatsPage />
            </ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
    </ErrorBoundary>
  );
}

const baseUrl = process.env.REACT_APP_BASE_URL || '/api/admin/AAHbedmPNf5xNO';
const authCookieName = 'auth_token';

function App() {

  return (
    <Router>
      <ThemeProvider>
        <NotificationProvider>
          <QueryClientProvider client={queryClient}>
            <RestClientProvider baseUrl={baseUrl} authCookieName={authCookieName}>
              <AppContent />
            </RestClientProvider>
          </QueryClientProvider>
        </NotificationProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
